import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Route, Switch } from 'react-router-dom';
import ViewContent from './contents/ViewContent';
import NewContent from './contents/NewContent';
import Content from './Contents';
import EditContent from './contents/EditContent';
import { PrivateRoute } from '../components';

const propTypes = {
  features: PropTypes.shape({}).isRequired,
  match: PropTypes.shape({
    path: PropTypes.string.isRequired,
  }).isRequired,
};

function ContentRouter({ match }) {
  return (
    <Switch>
      <Route exact path={`${match.path}`} component={Content} />
      <PrivateRoute exact path={`${match.path}/new`} component={NewContent} />
      <Route exact path={`${match.path}/:contentId`} component={ViewContent} />
      <PrivateRoute exact path={`${match.path}/:contentId/edit`} component={EditContent} />
    </Switch>
  );
}

function mapStateToProps(state) {
  return {
    features: state.features,
  };
}
ContentRouter.propTypes = propTypes;
export default connect(mapStateToProps)(ContentRouter);
